import { render } from "./CreateWebshopUserTypeModal.vue?vue&type=template&id=460d4a80&scoped=true"
import script from "./CreateWebshopUserTypeModal.vue?vue&type=script&lang=js"
export * from "./CreateWebshopUserTypeModal.vue?vue&type=script&lang=js"

import "./CreateWebshopUserTypeModal.vue?vue&type=style&index=0&id=460d4a80&lang=scss&scoped=true"

import exportComponent from "d:\\Beks\\EasyTicket\\easyticket.webshop.admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460d4a80"]])

export default __exports__